document.addEventListener("DOMContentLoaded", function () {  
    scroll(); 
});

function scroll() {

    window.onscroll = function () {
        a();
    };

    //const header = document.getElementById("page-header");
    const scrollToTopButton = document.getElementById("scroll-top-top");

    function a() {
		
        if (window.pageYOffset > 500) {
            scrollToTopButton.classList.add("is--visible");
			//header.classList.add("is--sticky");
			
        } else {
            scrollToTopButton.classList.remove("is--visible");
			//header.classList.remove("is--sticky");
        }
    }
}

jQuery(document).ready(function () {
	
	var scrollToTopButton = document.getElementById("scroll-top-top");
	scrollToTopButton.addEventListener('click', function (event) {
		event.preventDefault();
		$('html, body').animate({
			scrollTop: 0
		}, 800);
	});
	
    // open fullscreen menue
    jQuery(".nav-item.dropdown-toggle").on("click", function (ev) {
     //	ev.preventDefault();
     // jQuery("body").addClass("is--menu-open");
    });		

    jQuery("body").on("click", function (ev) {
    //	ev.preventDefault();
    //  jQuery("body").removeClass("is--menu-open");
    });		

	

	
});